import { render } from "./PaidProductDescription.vue?vue&type=template&id=411deb81&scoped=true"
import script from "./PaidProductDescription.vue?vue&type=script&lang=ts"
export * from "./PaidProductDescription.vue?vue&type=script&lang=ts"

import "./PaidProductDescription.vue?vue&type=style&index=0&id=411deb81&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-411deb81"

export default script